
export interface 修正移動型 {
  確定対象: boolean;
  移動: 移動型;
  修正移動先部署コード: string;
  修正移動年月日: Date | null;
  修正箱数: number;
  修正バラ数: number;
  再計算在庫数: number;
  移動後在庫数: number;
  修正前箱数バラ換算: number;
  修正前総移動数: number;
  修正後箱数バラ換算: number;
  修正後総移動数: number;
}

export interface 移動修正依頼内容型 {
  部署間移動シーケンス番号: number;
  更新バージョン: number;
  移動先部署コード: string;
  移動年月日: Date | null;
  箱数: number | null;
  バラ数: number | null;
  移動入力方法区分: string;
}

export interface 移動修正依頼型 {
  移動修正一覧: 移動修正依頼内容型[];
}

export function to修正移動型(record: 移動型): 修正移動型 {
  return {
    確定対象: false,
    移動: record,
    修正移動先部署コード: record.移動先部署コード,
    修正移動年月日: record.移動年月日,
    修正箱数: record.箱数,
    修正バラ数: record.バラ数,
    移動後在庫数:  record.現在庫数,
    再計算在庫数: 0,
    修正前箱数バラ換算: 0,
    修正前総移動数: 0,
    修正後箱数バラ換算: 0,
    修正後総移動数: 0,
  };
}

export function to移動修正依頼内容型(record: 修正移動型): 移動修正依頼内容型 {
  return {
    部署間移動シーケンス番号: record.移動.部署間移動シーケンス番号,
    更新バージョン: record.移動.更新バージョン,
    移動先部署コード: record.修正移動先部署コード,
    移動年月日: record.修正移動年月日,
    箱数: record.修正箱数,
    バラ数: record.修正バラ数,
    移動入力方法区分: record.移動.入力方法,
  };
}


export interface 移動修正登録者結果型 {
  登録者一覧: 移動修正登録者型[];
  利用者: 移動修正登録者型;
}

export interface 移動修正登録者型 {
  アカウント名: string | null;
  氏名: string;
}

export interface 移動修正移動先型 {
  部署コード: string | null;
  部署名: string;
}

export interface 移動修正検索依頼型 {
  在庫部署コード: string;
  移動先部署コード: string | null;
  移動年月日検索開始日: Date;
  移動年月日検索終了日: Date | null;
  登録者: string | null;
  商品名カナ検索文字列: string | null;
  メーカー名検索文字列: string | null;
  検索対象商品区分: string | null;
  検索対象データ作成区分: string | null;
}

export interface 移動削除依頼型 {
  部署間移動シーケンス番号: number;
  更新バージョン: number;
  移動入力方法区分: string;
}

export interface 移動型 {
  部署間移動シーケンス番号: number;
  商品コード: string;
  メーカー名: string;
  商品名: string;
  規格容量: string;
  在庫区分: string;
  移動元部署コード: string;
  移動先部署コード: string;
  移動年月日: Date;
  箱数: number;
  バラ数: number;
  有効期限: Date | null;
  入力方法: string;
  番号: number;
  現在庫数: number;
  入数: number;
  単位名: string;
  入数表示: string;
  単位表示: string;
  登録者: string;
  更新バージョン: number;
  移動後在庫数: number;
  バラ単位区分: バラ単位区分型;
  包装単位数: number;
  包装数量数: number;
}

export interface 移動修正検索結果型 {
  移動修正検索結果一覧: 移動型[];
  アラートメッセージ: string;
}

export enum バラ単位区分型 {
  包装単位 = '包装単位',
  包装数量 = '包装数量',
}
